"use strict";
/* eslint-disable finley/variable-length */
/* eslint-disable no-restricted-syntax */
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineBuffers = exports.toArrayBuffer = exports.fromBase64 = exports.toBase64 = exports.fromArrayBuffer = exports.toString = exports.fromString = exports.fromUint8Array = void 0;
exports.assertIsFinleyBuffer = assertIsFinleyBuffer;
/** Runtime guard + type assertion that a Uint8Array is backed by ArrayBuffer. */
function assertIsFinleyBuffer(buffer) {
    if (!(buffer.buffer instanceof ArrayBuffer)) {
        throw new Error('FinleyBuffer requires ArrayBuffer backing, got SharedArrayBuffer');
    }
}
/** Creates a FinleyBuffer from a Uint8Array, validating ArrayBuffer backing. */
const fromUint8Array = (uint8) => {
    assertIsFinleyBuffer(uint8);
    return uint8;
};
exports.fromUint8Array = fromUint8Array;
const fromString = (str) => {
    const encoder = new TextEncoder();
    return (0, exports.fromUint8Array)(encoder.encode(str));
};
exports.fromString = fromString;
const toString = (buffer) => {
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(buffer);
};
exports.toString = toString;
const fromArrayBuffer = (buffer) => {
    return (0, exports.fromUint8Array)(new Uint8Array(buffer));
};
exports.fromArrayBuffer = fromArrayBuffer;
const toBase64 = (buffer) => {
    let binary = '';
    const chunkSize = 8192; // process in chunks of 8192 bytes
    for (let i = 0; i < buffer.length; i += chunkSize) {
        const chunk = buffer.subarray(i, i + chunkSize);
        binary += String.fromCharCode.apply(null, Array.from(chunk));
    }
    return btoa(binary);
};
exports.toBase64 = toBase64;
const fromBase64 = (str) => {
    return (0, exports.fromUint8Array)(Uint8Array.from(atob(str), (c) => c.charCodeAt(0)));
};
exports.fromBase64 = fromBase64;
/**
 * Extracts a copy of the ArrayBuffer from a FinleyBuffer.
 * Slicing ensures the returned buffer contains only the relevant byte range.
 */
const toArrayBuffer = (buffer) => {
    return buffer.buffer.slice(buffer.byteOffset, buffer.byteOffset + buffer.byteLength);
};
exports.toArrayBuffer = toArrayBuffer;
const combineBuffers = (finleyBuffers) => {
    const byteLength = finleyBuffers.reduce((sum, item) => sum + item.byteLength, 0);
    const combinedBuffer = new Uint8Array(byteLength);
    let offset = 0;
    for (const item of finleyBuffers) {
        combinedBuffer.set(item, offset);
        offset += item.byteLength;
    }
    return (0, exports.fromUint8Array)(combinedBuffer);
};
exports.combineBuffers = combineBuffers;
//# sourceMappingURL=finleyBuffer.js.map